// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"599":"4d664b86","780":"7f5dc2b6"}[chunkId] + ".chunk.js";
};